import React, { Component, PropTypes } from 'react';
import {
  DatePicker,
  Toggle,
  Toolbar,
  ToolbarTitle,
  ToolbarGroup,
  TextField,
  Styles,
  RaisedButton
} from 'material-ui';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import * as SvgIcons from 'components/Material/SvgIcons';
import ScrollableContainer from 'components/ScrollableContainer';
import { StudentActions } from 'actions';

const { Spacing, Colors } = Styles;

class StudentExportContainer extends Component {
  static displayName = 'StudentExportContainer';

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    value: ''
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value})
  }

  export() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if(re.test(String(this.state.value).toLowerCase())){
      email = this.state.value;
    }
    const options = {
      startDate: this.refs.startDate.getDate(),
      endDate: this.refs.endDate.getDate(),
      withInactive: this.refs.withInactive.isToggled(),
      withProgress: this.refs.withProgress.isToggled(),
      recipientEmail: email
    };
    StudentActions.export(options);
  }

  render() {
    const toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('Export')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('Close')}
            tooltipPosition="bottom-center"
            svgIcon={<SvgIcons.ContentClear />}
            onTouchTap={::this.props.router.goBack}
          />
        </ToolbarGroup>
      </Toolbar>
    );
    const now = new Date();
    return (
      <ScrollableContainer
        header={toolbar}
        style={{ backgroundColor: Colors.fullWhite }}
      >
        <div style={{ padding: Spacing.desktopGutterMini }}>
          <DatePicker
            ref="startDate"
            maxDate={now}
            floatingLabelText={this.context.getIntlMessage('export.startDate')}
          />
          <DatePicker
            ref="endDate"
            defaultDate={now}
            maxDate={now}
            floatingLabelText={this.context.getIntlMessage('export.endDate')}
          />
          <TextField onChange={this.handleChange} hintText="Custom email" />
          <Toggle
            ref="withInactive"
            defaultToggled={false}
            label={this.context.getIntlMessage('export.user.withInactive')}
          />
          <Toggle
            ref="withProgress"
            defaultToggled={false}
            label={this.context.getIntlMessage('export.user.withProgress')}
          />
          <RaisedButton
            primary
            fullWidth
            label={this.context.getIntlMessage('Export')}
            onTouchTap={::this.export}
          />
        </div>
      </ScrollableContainer>
    );
  }
}

export default StudentExportContainer;



// WEBPACK FOOTER //
// ./src/js/containers/StudentExportContainer.js